import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { textStyles, tablet, colors } from '../../theme';
export default {
  container: {
    width: '100%',
    paddingTop: '2rem',
    paddingBottom: '4rem',
    borderTop: "1px solid ".concat(colors.pureBlack),
    '@media print': {
      display: 'none'
    }
  },
  wrapper: {
    paddingLeft: '2rem',
    paddingRight: '2rem'
  },
  contentLeft: _objectSpread(_objectSpread({}, textStyles.tiny), {}, {
    display: 'flex',
    '& li': {
      position: 'relative'
    },
    '& > li + li': {
      marginLeft: '2.5rem'
    },
    '& > li + li::before': {
      content: '"|"',
      position: 'absolute',
      display: 'block',
      left: '-1.25rem',
      top: '50%',
      transform: 'translateY(-52%)'
    }
  }, tablet(_objectSpread({}, textStyles.text)))
};